import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DynamicSidenav } from "../interfaces/dynamic-sidenav";
import { catchError, Observable, of } from "rxjs";

@Injectable({ providedIn: 'root' })
export class DynamicSidenavService {
  
  constructor(
    private http: HttpClient
  ) {}

  loadSidenav(): Observable<DynamicSidenav[]> {
    return this.http.get<DynamicSidenav[]>('api/navigation/nav').pipe(
      catchError((error) => {
        console.error("Errore nel caricamento della Sidenav:", error);
        return of([]); 
      })
    );
  }
}